module.exports = __webpack_public_path__ + "static/media/observer-perspective-large@3x.b49efea1.png";